import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    loadSchema: store.actions.request({
      input: store.actions.Data.asIs<{
        context: ents.core.admin.Context.ForZone
      }>(),
      output: store.actions.Data.asIs<{
        models: readonly ents.core.dms.models.Model[]
      }>(),
      reducers: {
        request: ({ state }) => ({ ...state, isLoading: true }),
        success: ({
          state,
          data: {
            response: { models },
          },
        }) => ({
          ...state,
          schema: new ents.core.dms.models.Schema({
            models,
          }),
          isLoading: false,
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          isLoading: false,
          error,
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
